/**
 * Sasha Home Page Module
 */

// Angular
import { Component, OnInit } from '@angular/core';
// RXJS
import { flatMap, map } from 'rxjs/operators';
// Afidium
import { SashaPageComponent } from '../sasha-page.component';
import { ViewsService } from 'libraries/view/views.service';
import { TEMPLATE_LABELS } from './config/wording';
import { ConfigurationResourceService } from 'libraries/service/resources/configuration/configurationResource.service';
import { ISearchStatus } from "app_sasha/shared/interfaces/ISearchStatus";
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ProcessingResultsContainerContexts } from "../processing-search-result/components/processing-result-container/processing-result-container.component";
import { ProcessingSearchParameters } from "../../shared/models/ProcessingSearchParameters";
import { IBookingSearchParameters } from 'libraries/interfaces/IBookingSearchParameters';
import { IProcessingSearchParameters } from 'app_sasha/shared/resources/processings/IProcessingSearchParameters';
import { ProcessingResourceService } from 'app_sasha/shared/resources/processings/processingResource.service';
import { IApiProcessingSearchResponse } from 'app_sasha/shared/resources/processings/IApiProcessingSearchResponse';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { DEFAULT_SEARCH_PARAMETERS_HOME, IDefaultSearchParametersHome } from 'app_sasha/shared/interfaces/IDefaultSearchParametersHomeConfig';

interface IPageStatus {
    lastBookings?: ISearchStatus;
    lastProcessings?: ISearchStatus;
}

interface ISearchConfig {
    [key: string]: IBookingSearchParameters | IProcessingSearchParameters;
}

@Component({
    selector: 'sasha-home',
    template: `
        <div class="app-wrapper app-sasha">
            <div class="inactive-breadcrumb">
                <div class="item">{{labels.home}}</div>
            </div>
            <div class="container">
                <div class="col1 flex-2 sep-right">
                    <booking-main></booking-main>
                </div>
                <div class="col2 flex-1">
                    <sasha-side-links></sasha-side-links>
                    <processing-results-container [context]="resultContainerContext"
                                                  [searchStatus]="pageStatus.lastProcessings"
                                                  [recordset]="(lastProcessingsResponse &&
                                                lastProcessingsResponse.recordset ?
                                                lastProcessingsResponse.recordset : [])"
                                                  [processings]="(lastProcessingsResponse &&
                                                lastProcessingsResponse.processing ?
                                                lastProcessingsResponse.processing : [])">
                        <div class="processing-results-footer">
                            <a [routerLink]="['/sasha/processing/search-result']"
                               [queryParams]="searchProcessingsParameters.convertToUrlParameters()"
                               class="btn actionLink">
                                {{labels.seeMore}}
                            </a>
                        </div>
                    </processing-results-container>
                </div>
            </div>
        </div>`,
    styleUrls: ['./sasha-home.component.scss']
})
export class SashaHomeComponent extends SashaPageComponent implements OnInit {
    public pageStatus: IPageStatus;
    public labels: { [key: string]: string } = TEMPLATE_LABELS;
    public searchProcessingsParameters: ProcessingSearchParameters = new ProcessingSearchParameters();

    public lastProcessingsResponse: IApiProcessingSearchResponse;
    public resultContainerContext: ProcessingResultsContainerContexts =
        ProcessingResultsContainerContexts.HOME;

    constructor(
        public views: ViewsService,
        public appRootService: AppRootService,
        private readonly processingResource: ProcessingResourceService,
        private readonly configurationResourceService: ConfigurationResourceService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
        super(views, appRootService);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.pageStatus = {
            lastProcessings: { isLoading: true },
        };

        this.configurationResourceService
            .get<IDefaultSearchParametersHome>(['wui', 'app_sasha', 'config', 'searches', 'home.json'], DEFAULT_SEARCH_PARAMETERS_HOME).pipe(
                map((configResponse: IDefaultSearchParametersHome): IProcessingSearchParameters => configResponse.processing as IProcessingSearchParameters),
                flatMap((configResponse: IProcessingSearchParameters) => this.processingResource.search(configResponse)),
            )
            .subscribe(
                (response: IApiProcessingSearchResponse) => {
                    this.lastProcessingsResponse = response;
                },
                (error: Error) => {
                    this.errorTracingService.captureException(error);
                    this.pageStatus.lastProcessings = getSearchStatus(this.pageStatus.lastProcessings, {
                        isError: true,
                        errorMessage: error.message
                    });
                },
                () => {
                    this.pageStatus.lastProcessings = getSearchStatus(this.pageStatus.lastProcessings, {
                        isLoading: false,
                    });
                }
            );
    }
}

function getSearchStatus(status: ISearchStatus, newStatus?: ISearchStatus): ISearchStatus {
    const defaultStatus: ISearchStatus = {
        isLoading: false,
        isError: false,
    };

    return { ...(status || defaultStatus), ...newStatus };
}
